var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',{staticClass:"s-footer-mobile"},[_vm._l((_vm.bottomMenu),function(menu,index){return [(menu.condition)?_c('router-link',{key:index,class:menu.classNames,attrs:{"to":menu.action}},[_vm._v(_vm._s(menu.name))]):_vm._e()]})],2)}
var staticRenderFns = []

export { render, staticRenderFns }